import { APP_JSON } from '../../constants/common-enums';
import fetchReq from '../../helpers/fetch';
import StaticIdSingletonClass from '../../helpers/static-id';
import CONFIG from '../../settings';

const API = {
  probe: (otpCode, accessToken, sessionId) => {
    const dfpSessionId = sessionId || CONFIG.application.defaults.dfpSessionId;
    const requestPayload = {
      grant_type: 'authorization_probe',
      probes_ref: [
        {
          data: {
            type: 'OTP',
            value: otpCode
          }
        }
      ]
    };
    const headers = {
      Accept: APP_JSON,
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': APP_JSON,
      dfpSessionId
    };
    const options = {
      body: requestPayload,
      headers,
      method: 'POST',
      url: CONFIG.application.api.token.probe(StaticIdSingletonClass.namespace)
    };

    return fetchReq(options);
  },
  /**
   * @param {string} accessToken
   * @param {string} sessionId
   * @returns {object} response object
   */
  reissuance: (accessToken, sessionId) => {
    const dfpSessionId = sessionId || CONFIG.application.defaults.dfpSessionId;
    const requestPayload = {
      grant_type: 'authorization_probe_reissuance',
      probes_ref: [
        {
          data: {
            type: 'OTP'
          }
        }
      ]
    };
    const headers = {
      Accept: APP_JSON,
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': APP_JSON,
      dfpSessionId
    };
    const options = {
      body: requestPayload,
      headers,
      method: 'POST',
      url: CONFIG.application.api.token.reissuance(StaticIdSingletonClass.namespace)
    };

    return fetchReq(options);
  }
};

export default API;
